export default {
      id: "i-yt-black-usage",
      viewBox: "0 0 33 33",
      url: __webpack_public_path__ + "img/sprite.svg#i-yt-black",
      toString: function () {
        return this.url;
      }
    }